export const ToastTiming = {
  DISPLAY_TIME_SUCCESS: 5000,
  DISPLAY_TIME_ERROR: 12000,
};
